import jsonapi from 'jsonapi-parse';
import TechademiaCheckOrder from '~/models/read/TechademiaCheckOrder';

export default $axios => () => ({
    async create(orderId) {
        let response = await $axios.$post(`/rest/student/citation-checker/${orderId}`);
        return new TechademiaCheckOrder(jsonapi.parse(response).data);
    },

    async get(orderId) {
        let response = await $axios.$get(`/rest/student/citation-checker/${orderId}`);
        return new TechademiaCheckOrder(jsonapi.parse(response).data);
    },
});
